import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const Tick = styled.div<{
  barsHeight: number;
  barsTilt: number;
  barsWidth: number;
  size: number;
}>((props) => ({
  transformOrigin: '40px 40px',
  animation: `${spin} 1.2s linear infinite`,
  '&:after': {
    content: '" "',
    display: 'block',
    position: 'absolute',
    left: `${props.barsTilt}px`,
    borderRadius: '20%',
    background: colors.grays['50'],
    width: `${props.barsWidth}px`,
    height: `${props.barsHeight}px`,
    top: `${props.size}px`,
  },
}));

type TicksProps = {
  height: number;
  size?: number;
  width: number;
};

export const Ticks = ({ height, width, size = 3 }: TicksProps) => (
  <>
    {[
      ...new Array(12).fill(null).map((_, i) => (
        <Tick
          barsHeight={18}
          barsTilt={37}
          barsWidth={6}
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          size={size}
          style={{
            animationDelay: `${-1.1 + i * 0.1}s`,
            transform: `rotate(${i * 30}deg)`,
            transformOrigin: `${height / 2}px ${width / 2}px`,
          }}
        />
      )),
    ]}
  </>
);
